import BaseApiService from './api.base.service'

class DynamicFormsApiService extends BaseApiService {
  constructor() {
    super('bom')
  }

  getDynamicForm(formId) {
    return this.callGet(`dynamic-forms/${formId}`)
  }
  getNewsletters() {
    return this.callGet('dynamic-forms/newsletters')
  }

  getNewsletterList() {
    return this.callGet('dynamic-forms/newsletters')
  }

  getDynamicFormsList() {
    return this.callGet('dynamic-forms/list')
  }

  insertDynamicForm(formData) {
    return this.callPost('dynamic-forms', formData, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  updateDynamicForm(formId, formData) {
    return this.callPut(`dynamic-forms/${formId}`, formData)
  }

  duplicateDynamicForm(formId) {
    return this.callPost(`dynamic-forms/${formId}/duplicate`)
  }

  deleteDynamicForm(formId) {
    return this.callDelete(`dynamic-forms/${formId}`)
  }

  submitDynamicForm(dataSubmitted) {
    return this.callPost('dynamic-forms/submit', dataSubmitted, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  getFormAnswers(formId) {
    return this.callGet(`dynamic-forms/${formId}/answers`)
  }
  deleteDynamicFormAnswer(formId, submissionId) {
    return this.callDelete(`dynamic-forms/${formId}/answers/${submissionId}`)
  }
}
export const dynamicFormsApi = new DynamicFormsApiService()
